import { usePAChecklistFollowUp } from "../../pa_checklist_followup_context";
import styles from '../../pa_checklist_followup.module.scss';

const statusList = {
  4: { label: '04 - APROVADO', color: '#B4E380' },
  5: { label: '05 - APROVADO COM RESTRIÇÕES', color: '#F6FB7A' },
  7: { label: '07 - DEVOLUÇÃO PARCIAL', color: '#FFBABA' },
  6: { label: '06 - DEVOLUÇÃO TOTAL', color: '#FF7777' },
  8: { label: '08 - REPROVADO NA PROVA DE ROUPA', color: '#FFBABA' },
}

export default function StatusSugerido() {
  const { dadosResultadoFinal } = usePAChecklistFollowUp()
  const {
    qtdeTotalProd,
    limitePecasDefeituosas,
    nfSegundaQualidade,
    produtoDeCouro,
    pecasDefeituosasRev,
    pecasDefeituosasAnalise,
    pecasDevolvidasRev,
    pecasDevolvidasAnalise,
    totalPecasDefeituosas,
    totalPecasDevolvidas,
    statusSugerido,
    statusChecklist,
    statusProvaRoupa,
    resCaixa,
    resRevisao
  } = dadosResultadoFinal;

  return (
    <div className={styles.wrapper_st_sugerido}>
      <div className={styles.body_st_sugerido}>
        <div className={styles.col_st_sugerido}>
          <div>
            <div className={styles.indica_s_label}>Extrato de peças defeituosas</div>
            <div>Qtde. Entrada: <span className={styles.indica_s_value}>{qtdeTotalProd}</span></div>
            <div>Limite máximo p/ devolução total: <span className={styles.indica_s_value}>{limitePecasDefeituosas}</span></div>
            <div>Segunda Qualidade: <span className={styles.indica_s_value}>{nfSegundaQualidade ? 'Sim' : 'Não'}</span></div>
            <div>Produto de Couro: <span className={styles.indica_s_value}>{produtoDeCouro ? 'Sim' : 'Não'}</span></div>
          </div>
          <div className={styles.separator} />
          <div>
            <div className={styles.indica_s_label}>Indica Destino Devolução</div>
            <div>Peças Devolvidas (Revisão): <span className={styles.indica_s_value}>{pecasDevolvidasRev}</span></div>
            <div>Peças Devolvidas (Checklist): <span className={styles.indica_s_value}>{pecasDevolvidasAnalise}</span></div>
          </div>
        </div>
        <div className={styles.vertical_separator_full} />
        <div className={styles.col_st_sugerido}>
          <div>
            <div className={styles.indica_s_label}>Direcionamento Final</div>
            <div>Total Destinado aos Estoques: <span className={styles.indica_s_value}>{totalPecasDefeituosas}</span></div>
            <div>Total Destinado à Devolução: <span className={styles.indica_s_value}>{totalPecasDevolvidas}</span></div>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
          </div>
          <div className={styles.separator} />
          <div>
            <div className={styles.indica_s_label}>Indica Destino aos estoques</div>
            <div>Peças Defeituosas (Revisão): <span className={styles.indica_s_value}>{pecasDefeituosasRev}</span></div>
            <div>Peças Defeituosas (Checklist): <span className={styles.indica_s_value}>{pecasDefeituosasAnalise}</span></div>
          </div>
        </div>
      </div>

      <div className={styles.separator} />

      <div className={styles.body_st_sugerido}>
        <div style={{marginRight: 'auto'}}>
          <div className={styles.indica_s_label}>Revisão</div>
          <div>Composição Tag Divergente? <span className={styles.indica_s_value}>{resRevisao?.composicao_tag_divergente ? 'Sim' : 'Não'}</span></div>
          <div>Preço Tag Divergente? <span className={styles.indica_s_value}>{resRevisao?.preco_tag_divergente ? 'Sim' : 'Não'}</span></div>
        </div>
        <div className={styles.vertical_separator_full} />
        <div style={{marginRight: 'auto'}}>
          <div className={styles.indica_s_label}>Checklist</div>
          <div>Composição Tag Divergente? <span className={styles.indica_s_value}>{resCaixa?.composicao_tag_divergente ? 'Sim' : 'Não'}</span></div>
          <div>Preço Tag Divergente? <span className={styles.indica_s_value}>{resCaixa?.preco_tag_divergente ? 'Sim' : 'Não'}</span></div>
        </div>
      </div>

      <div className={styles.separator} />

      {(statusChecklist || statusProvaRoupa) && (
        <div
          style={{ display: 'flex', justifyContent: 'center', gap: '16px', margin: 'auto' }}
        >
          <div>
            <div style={{ fontWeight: '500', color: '#000000AE', alignSelf: 'center' }}>Status sem prova de roupa:</div>
            <div
              className={styles.status_sugerido_card}
              style={{ backgroundColor: statusList[statusChecklist]?.color || 'F6FB7A' }}
            >
              {statusList[statusChecklist]?.label}
            </div>
          </div>
          <div className={styles.vertical_separator_full} />
          <div>
            <div style={{ fontWeight: '500', color: '#000000AE', alignSelf: 'center' }}>Status com prova de roupa:</div>
            <div
              className={styles.status_sugerido_card}
              style={{ backgroundColor: statusList[statusProvaRoupa]?.color || 'F6FB7A' }}
            >
              {statusList[statusProvaRoupa]?.label}
            </div>
          </div>
          <div className={styles.vertical_separator_full} />
          <div>
            <div style={{ fontWeight: '500', color: '#000000AE', alignSelf: 'center' }}>Sugestão de status final:</div>
            <div
              className={styles.status_sugerido_card}
              style={{ backgroundColor: statusList[statusSugerido]?.color || 'F6FB7A' }}
            >
              {statusList[statusSugerido]?.label}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
